import React, { useState, useEffect } from 'react';
import { Button, Card, Table, Modal, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import {
  getAllQuestions,
  getAllQuestionTypes,
  addQuestion,
  updateQuestion,
  deleteQuestion
} from '../services/questionService';

const Questions = () => {
  const [questions, setQuestions] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [newName, setNewName] = useState('');
  const [newQuestionTypeId, setNewQuestionTypeId] = useState('');
  const [editingQuestionId, setEditingQuestionId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editTypeId, setEditTypeId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteCandidate, setDeleteCandidate] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchQuestions();
    fetchQuestionTypes();
  }, []);

  const fetchQuestions = async () => {
    try {
      const list = await getAllQuestions();
      setQuestions(list);
    } catch {
      toast.error('Sorular yüklenirken hata oluştu!');
    }
  };

  const fetchQuestionTypes = async () => {
    try {
      const list = await getAllQuestionTypes();
      setQuestionTypes(list);
    } catch {
      toast.error('Soru tipleri yüklenirken hata oluştu!');
    }
  };

  const getTypeName = (typeId) => {
    const found = questionTypes.find((qt) => qt.id === typeId);
    return found ? found.name : 'Bilinmiyor';
  };

  const handleAdd = async () => {
    if (!newName || !newQuestionTypeId) {
      toast.error('Lütfen soru açıklaması ve tip seçiniz!');
      return;
    }
    try {
      const resp = await addQuestion({ name: newName, questionTypeId: newQuestionTypeId });
      if (!resp?.Status) return toast.error(resp.Message);
      toast.success(resp.Message);
      setNewName('');
      setNewQuestionTypeId('');
      fetchQuestions();
    } catch {
      toast.error('Soru eklenirken hata oluştu!');
    }
  };

  const handleEdit = (question) => {
    setEditingQuestionId(question.id);
    setEditName(question.name || '');
    setEditTypeId(question.questionTypeId || '');
  };

  const handleUpdate = async (id) => {
    try {
      const resp = await updateQuestion({ id, name: editName, questionTypeId: editTypeId });
      if (!resp?.Status) return toast.error(resp.Message);
      toast.success(resp.Message);
      setEditingQuestionId(null);
      setEditName('');
      setEditTypeId('');
      fetchQuestions();
    } catch {
      toast.error('Güncelleme sırasında hata oluştu!');
    }
  };

  const handleDeleteModal = (question) => {
    setDeleteCandidate(question);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const resp = await deleteQuestion(deleteCandidate.id);
      if (!resp?.Status) return toast.error(resp.Message);
      toast.success(resp.Message);
      setShowDeleteModal(false);
      setDeleteCandidate(null);
      fetchQuestions();
    } catch {
      toast.error('Silme sırasında hata oluştu!');
    }
  };

  return (
    <Card>
      <Card.Header><h4 className="mb-0">Soru Yönetimi</h4></Card.Header>
      <Card.Body>
        <div className="mb-4">
          <div className="row g-2">
            <div className="col-md-6">
              <Form.Control type="text" placeholder="Soru Açıklaması" value={newName} onChange={(e) => setNewName(e.target.value)} />
            </div>
            <div className="col-md-4">
              <Form.Select value={newQuestionTypeId} onChange={(e) => setNewQuestionTypeId(e.target.value)}>
                <option value="">Soru Tipi Seçin</option>
                {questionTypes.map(qt => <option key={qt.id} value={qt.id}>{qt.name}</option>)}
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button variant="success" className="w-100" onClick={handleAdd}>Ekle</Button>
            </div>
          </div>
        </div>

        <Table bordered hover responsive>
          <thead><tr><th>ID</th><th>Açıklama</th><th>Tip</th><th>İşlem</th></tr></thead>
          <tbody>
            {questions.map(q => (
              <tr key={q.id}>
                <td>{q.id}</td>
                <td>{editingQuestionId === q.id
                  ? <Form.Control value={editName} onChange={(e) => setEditName(e.target.value)} />
                  : q.name}
                </td>
                <td>{editingQuestionId === q.id ? (
                  <Form.Select value={editTypeId} onChange={(e) => setEditTypeId(e.target.value)}>
                    <option value="">Soru Tipi Seçin</option>
                    {questionTypes.map(qt => <option key={qt.id} value={qt.id}>{qt.name}</option>)}
                  </Form.Select>) : getTypeName(q.questionTypeId)}
                </td>
                <td>{editingQuestionId === q.id ? (
                  <>
                    <Button size="sm" onClick={() => handleUpdate(q.id)}>Kaydet</Button>{' '}
                    <Button size="sm" variant="secondary" onClick={() => setEditingQuestionId(null)}>İptal</Button>
                  </>) : (
                  <>
                    <Button size="sm" variant="warning" onClick={() => handleEdit(q)}>Düzenle</Button>{' '}
                    <Button size="sm" variant="danger" onClick={() => handleDeleteModal(q)}>Sil</Button>{' '}
                    <Button size="sm" variant="info" onClick={() => navigate(`/questions/${q.id}/choices`)}>Seçenekler</Button>
                  </>)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton><Modal.Title>Soru Sil</Modal.Title></Modal.Header>
        <Modal.Body>{deleteCandidate?.name} adlı soruyu silmek istediğinize emin misiniz?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Vazgeç</Button>
          <Button variant="danger" onClick={handleConfirmDelete}>Evet, Sil</Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default Questions;
